export const en = {
  // topnav
  Search: 'Search',
  FullScreen: 'Full screen',
  Refresh: 'Refresh',
  selected: 'selected',

  LogIn: 'Log In',
  LogOut: 'Log Out',
  SignUp: 'Sign Up',
  SignIn: 'Sign In',

  // sidenav
  Alerts: 'Alerts',
  Heartbeats: 'Heartbeats',
  Users: 'Users',
  Groups: 'Groups',
  Customers: 'Customers',
  Blackouts: 'Blackouts',
  Permissions: 'Permissions',
  APIKeys: 'API Keys',
  Labels: 'Labels',
  Reports: 'Reports',
  More: 'More',
  Settings: 'Settings',
  Help: 'Help',
  About: 'About',
  AedifionHome: 'aedifion Home',
  AedifionIO: 'aedifion .io',
  AedifionDocs: 'Documentation',
  ProjectNotAllowed: 'You have no access to the project of this alarm. Please contact your administrator to receive the needed permissions.',
  Project: 'Project',
  NoProjectAssigned: 'This alarm is not assigned to any project. Therefore, no graph can be plotted.',
  TimeseriesError: 'Could not fetch any timeseries for the alarms\' datapoint.',
  NoDatapointAssigned: 'This alarm is not assigned to any datapoint. Therefore, no graph can be plotted.',

  // more
  ChooseDisplayDensity: 'Choose a display density',
  DisplayDensity: 'Display density',
  Comfortable: 'Comfortable',
  Compact: 'Compact',
  Panel: 'Panel',
  Hide: 'Hide',
  Show: 'Show',
  DownloadAsCsv: 'Download as CSV',

  // Groups store
  UserAddedGroup: 'User added to group.',
  UserRemovedGroup: 'User removed from group.',

  // Preferences store
  SettingsSaved: 'Settings saved.',
  SettingsReset: 'Settings reset to defaults.',
  SettingsError: 'Could not retrieve user preferences.',

  // Users store
  UserStatusSaved: 'User status saved.',
  EmailSaved: 'Email verified saved.',

  // statuses
  Open: 'Open',
  Assign: 'Assign',
  Ack: 'Ack',
  Shelved: 'Shelved',
  Blackout: 'Blackout',
  Closed: 'Closed',
  Expired: 'Expired',
  Unknown: 'Unknown',
  NotValid: 'Not Valid',

  // operator actions
  Open: 'Open',
  Assign: 'Assign',
  Ack: 'Ack',
  Unack: 'Unack',
  Shelve: 'Shelve',
  Unshelve: 'Unshelve',
  Close: 'Close',
  Watch: 'Watch',
  Unwatch: 'Unwatch',
  AddNote: 'Add note',
  Delete: 'Delete',

  // Alert actions
  TextIsRequired: 'Text is required',
  TextMustBeLessThan: 'Text must be less than',
  characters: 'characters',

  // Alert detail
  AlertId: 'Alert ID',
  LastReceiveAlertId: 'Last Receive Alert ID',
  CreateTime: 'Create Time',
  ReceiveTime: 'Receive Time',
  LastReceiveTime: 'Last Receive Time',
  Customer: 'Customer',
  Service: 'Service',
  Environment: 'Environment',
  Resource: 'Resource',
  Event: 'Event',
  Correlate: 'Correlate',
  Group: 'Group',
  Severity: 'Severity',
  Status: 'Status',
  Value: 'Value',
  Text: 'Text',
  TrendIndication: 'Trend Indication',
  Timeout: 'Timeout',
  Type: 'Type',
  DuplicateCount: 'Duplicate count',
  Repeat: 'Repeat',
  Origin: 'Origin',
  Tags: 'Tags',
  Attributes: 'Attributes',
  History: 'History',
  Data: 'Data',

  Details: 'Details',
  addedNoteOn: 'added note on',
  by: 'by',

  // Alert history
  UpdateTime: 'Update Time',
  Updated: 'Updated',
  User: 'User',

  // Alert list
  Loading: 'Loading',
  NoDataAvailable: 'No data available',
  ALL: 'ALL',
  Description: 'Description',
  Attribute: 'Attribute',
  TimeoutLeft: 'Timeout',
  Dupl: 'Dupl.',
  PrevSeverity: 'Prev. Severity',
  LastReceiveId: 'Last Receive ID',
  LastNote: 'Last Note',

  // Alert list filter
  Filters: 'Filters',
  FilterDescription: 'Filter results by text search',
  AllStatuses: 'All statuses',
  StatusDescription: 'Choose one or more status',
  AllCustomers: 'All customers',
  CustomerDescription: 'Choose one or more customer',
  AllServices: 'All services',
  ServiceDescription: 'Choose one or more service',
  AllGroups: 'All groups',
  GroupDescription: 'Choose one or more group',

  Latest: 'Latest',
  Hour: '1 hour',
  SixHours: '6 hours',
  TwelveHours: '12 hours',
  SelectRange: 'Select Range',

  DateTime: 'Date/Time',
  StartDate: 'Start Date',
  EndDate: 'End Date',
  Time: 'Time',
  Apply: 'Apply',
  Reset: 'Reset',

  // API keys
  APIKey: 'API Key',
  Search: 'Search',
  Customer: 'Customer',
  Scopes: 'Scopes',
  Expires: 'Expires',
  Active: 'Active',
  Expired: 'Expired',
  Slow: 'Slow',

  User: 'User',
  LastUsed: 'Last Used',
  Actions: 'Actions',

  Copy: 'Copy',
  Copied: 'Copied!',
  NewApiKey: 'New API Key',
  EditApiKey: 'Edit API Key',

  // Blackouts
  ChooseService: 'Choose one or more service',
  Start: 'Start',
  End: 'End',
  Created: 'Created',
  Reason: 'Reason',
  NewBlackout: 'New Blackout',
  EditBlackout: 'Edit Blackout',

  // Customers
  LookUp: 'Look Up',
  LookUpDescription: 'Use login, Keycloak role, GitHub org, GitLab group or email domain',
  NewCustomer: 'New Customer',
  EditCustomer: 'Edit Customer',

  // Groups
  AddRemoveUsers: 'Add/Remove Users',
  Addusers: 'Add users',
  UsersInGroup: 'Users in group',
  NumberUsers: 'Number of Users',
  NewGroup: 'New Group',
  EditGroup: 'Edit Group',

  // Heartbeats
  Latency: 'Latency',
  Since: 'Since',

  // Manifest
  API: 'API',
  OpenGitHub: 'Open in GitHub',
  WebUI: 'Web UI',
  Build: 'Build',
  Date: 'Date',
  GitRevision: 'Git Revision',
  APIEndpoint: 'API Endpoint',

  // Perms
  Role: 'Role',
  Scope: 'Scope',
  SystemRole: 'System role',
  NewPermission: 'New permission',
  EditPermission: 'Edit permission',

  // Preferences
  ApplicationSettings: 'Application Settings',
  DarkTheme: 'Dark Theme',
  PlaySounds: 'Play notification sounds',
  LanguageSettings: 'Language settings',
  Languages: 'Languages',
  English: 'English',
  French: 'French',
  German: 'German',
  DateTimeSettings: 'Date and time settings',
  LongDate: 'Long date format',
  MediumDate: 'Medium date format',
  ShortTime: 'Short time format',
  DisplayMode: 'Display mode',
  UseLocal: 'Use local date & time',
  UseUTC: 'Use Coordinated Universal Time (UTC)',
  AlertSettings: 'Alert summary settings',
  PageRows: 'Rows per page',
  rows: 'rows',
  RefreshInterval: 'Refresh interval',
  seconds: 'seconds',
  ShelveTimeout: 'Shelve timeout',
  hours: 'hours',

  // Profile Me
  EmailVerified: 'Email verified',
  EmailNotVerified: 'Email not verified',
  Customers: 'Customers',
  Organizations: 'Organizations',
  Groups: 'Groups',
  Roles: 'Roles',
  Scopes: 'Scopes',
  others: 'others',

  // Status
  LastUpdate: 'Last Update',
  Uptime: 'Uptime',
  Metric: 'Metric',
  Type: 'Type',
  Name: 'Name',
  Value: 'Value',
  AvgTime: 'Avg. Time',

  // Users
  Active: 'Active',
  Inactive: 'Inactive',
  Login: 'Login',
  Email: 'Email',
  Verified: 'Verified',
  Comment: 'Comment',
  VerifiedOrNot: 'Verified?',
  LastLogin: 'Last Login',
  NewUser: 'New user',
  EditUser: 'Edit user',

  // Reports
  TopFlapping: 'Top 10 Flapping',
  TopFlappingDescription: 'Chattering and fleeting alert sources that have generated the most number of alert severity changes.',
  TopOffenders: 'Top 10 Offenders',
  TopOffendersDescription: 'Frequently occurring alert sources that have generated the most number of alerts and alert duplicates.',
  TopStanding: 'Top 10 Standing',
  TopStandingDescription: 'Stale alert sources that have active alerts for a prolonged duration.',
  
  Count: 'Count',
  DuplCount: 'Dupl. Count',
  Services: 'Services',
  Resources: 'Resources',

  // User Confirm
  Thanks: 'Thanks!',
  YouCanNowLogin1: 'You can now',
  YouCanNowLogin2: 'login.',
  EmailConfirmFailed: 'Sorry, there was a problem confirming your email address',
  TryAgain: 'Please try again',

  // User Forgot
  ResetLink: 'Enter your email and we\'ll send you a reset link',
  AlreadyHaveAccount: 'Already have an account?',
  CheckEmail: 'Check your email for a reset link...',
  ReturnSignIn: 'Return to Sign In',
  ResetEmailSent: 'Reset email sent successfully!',

  // User Login
  LoginToContinue: 'Log in to Alerta to continue',
  Username: 'Username',
  Password: 'Password',
  CreateAccount: 'Create Account',
  ForgotPassword: 'Forgot Password?',
  UnspecifiedProblem: 'Sorry, there was a problem',
  AuthWith: 'Authenticating with',
  AuthInProgress: 'Authenticating...',
  AuthNotPossible: 'Sorry, it is not possible to authenticate',
  AuthProviderUnknown: 'Unknown authentication provider',

  // User Logout
  LoggedOut: 'You have been logged out.',

  // User Reset
  ChooseNewPassword: 'Choose a new password',
  ConfirmPassword: 'Confirm Password',
  ResetPassword: 'Reset Password',

  // User Signup
  CreateAlertaAccount: 'Create your Alerta account',
  SignUpNotAvailable: 'Sorry, sign up is not currently available',
  FullName: 'Full Name',
  Min6Char: 'Min 6 characters',
  PasswordNotMatch: 'Passwords entered don\'t match',

  // Labels
  scope: 'scope',
  role: 'role',
  customer: 'customer',
  group: 'group',

  // General
  ConfirmDelete: 'Are you sure you want to delete this item?',
  Error: 'Error',
  Send: 'Send',
  Required: 'Required',
  Cancel: 'Cancel',
  Save: 'Save',
  NoDisplay: 'Sorry, nothing to display here :(',
  SearchNoResult1: 'Your search for ',
  SearchNoResult2: 'found no results.',
  OK: 'OK',

  // ENDS.
}
